import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { UserType } from "types/UsersTypes";
import { useLogout } from "hooks/auth/";

export function useGetMe() {
  const { mutate: logout } = useLogout({});
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        const response = await axiosInstance.get("/users/me");
        return response.data;
      } catch (firstError) {
        try {
          const response = await axiosInstance.get("/users/me");
          return response.data;
        } catch (secondError) {
          if (window.location.href.includes('dashboard')) {
            await logout();
          }
          throw secondError; 
        }
      }
    },
    select: (data: { user: UserType }) => data.user,
    retry: false, 
  });
}